(function() {
  function getCk(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  var wrap = document.getElementById('sp-global-progress-wrap');
  if (!wrap) return;

  if (document.querySelector('[data-no-builder="true"]')) {
    wrap.style.display = 'none';
    return;
  }

  var ctx = wrap.getAttribute('data-page-context');

  var diamondRaw = getCk('_diamonmd') || getCk('_diamond');
  var diamond = null;
  if (diamondRaw) { try { diamond = JSON.parse(diamondRaw); } catch(e) {} }
  var hasDiamond = !!(diamond && diamond.sku);

  var ringRaw = getCk('_ring');
  var ring = null;
  if (ringRaw) { try { ring = JSON.parse(ringRaw); } catch(e) {} }
  var hasRing = !!(ring && ring.handle);

  var isFinal = window.location.search.indexOf('view=final-ring') > -1;

  var steps;
  if (isFinal) {
    steps = hasDiamond
      ? [
          { label: 'Choose a Diamond', state: 'completed' },
          { label: 'Choose a Setting', state: 'completed' },
          { label: 'Complete Your Ring', state: 'active' }
        ]
      : [
          { label: 'Choose a Setting', state: 'completed' },
          { label: 'Choose a Diamond', state: 'completed' },
          { label: 'Complete Your Ring', state: 'active' }
        ];
  } else if (ctx === 'settings-collection' || ctx === 'settings-product') {
    steps = hasDiamond
      ? [
          { label: 'Choose a Diamond', state: 'completed' },
          { label: 'Choose a Setting', state: 'active' },
          { label: 'Complete Your Ring', state: 'upcoming' }
        ]
      : [
          { label: 'Choose a Setting', state: 'active' },
          { label: 'Choose a Diamond', state: 'upcoming' },
          { label: 'Complete Your Ring', state: 'upcoming' }
        ];
  } else if (ctx === 'diamond-product') {
    steps = hasRing
      ? [
          { label: 'Choose a Setting', state: 'completed' },
          { label: 'Choose a Diamond', state: 'active' },
          { label: 'Complete Your Ring', state: 'upcoming' }
        ]
      : [
          { label: 'Choose a Diamond', state: 'active' },
          { label: 'Choose a Setting', state: 'upcoming' },
          { label: 'Complete Your Ring', state: 'upcoming' }
        ];
  } else if (ctx === 'diamond-collection') {
    steps = hasRing
      ? [
          { label: 'Choose a Setting', state: 'completed' },
          { label: 'Choose a Diamond', state: 'active' },
          { label: 'Complete Your Ring', state: 'upcoming' }
        ]
      : [
          { label: 'Choose a Diamond', state: 'active' },
          { label: 'Choose a Setting', state: 'upcoming' },
          { label: 'Complete Your Ring', state: 'upcoming' }
        ];
  } else {
    steps = [
      { label: 'Choose a Setting', state: 'active' },
      { label: 'Choose a Diamond', state: 'upcoming' },
      { label: 'Complete Your Ring', state: 'upcoming' }
    ];
  }

  var icons = {
    'Setting': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="15" r="6"/><path d="M12 9V4"/><path d="M9 5.5L12 4l3 1.5"/><path d="M8 10l-1-3"/><path d="M16 10l1-3"/></svg>',
    'Diamond': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 6.5h15l3 5-10.5 11L1.5 11.5z"/><path d="M1.5 11.5h21"/><path d="M12 22.5l-4-11 4-5 4 5-4 11"/><path d="M7.5 6.5l4.5 5 4.5-5"/></svg>',
    'Complete': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="15" r="6"/><path d="M9.5 10.5l2.5-4 2.5 4"/><path d="M9.5 10.5h5"/><path d="M8.5 11l-0.5 0.5"/><path d="M15.5 11l0.5 0.5"/></svg>'
  };

  var html = '<div class="sp-progress">';
  for (var i = 0; i < steps.length; i++) {
    var s = steps[i];
    var cls = 'sp-progress__step';
    if (s.state === 'active') cls += ' sp-progress__step--active';
    else if (s.state === 'completed') cls += ' sp-progress__step--completed';

    var isDiamondStep = s.label.indexOf('Diamond') > -1;
    var isSettingStep = s.label.indexOf('Setting') > -1;
    var iconKey = isSettingStep ? 'Setting' : (isDiamondStep ? 'Diamond' : 'Complete');

    var smallText, mainText;
    if (isSettingStep) {
      if (hasRing && s.state === 'completed') {
        smallText = 'Your setting';
        mainText = 'SETTING';
      } else {
        smallText = 'Select your'; mainText = 'SETTING';
      }
    } else if (isDiamondStep) {
      if (hasDiamond && s.state === 'completed') {
        smallText = 'Your stone';
        var parts = [];
        if (diamond.carat)   parts.push(String(diamond.carat) + 'CT');
        if (diamond.shape)   parts.push(String(diamond.shape).toUpperCase());
        if (diamond.color)   parts.push(String(diamond.color).toUpperCase());
        if (diamond.clarity) parts.push(String(diamond.clarity).toUpperCase());
        mainText = parts.length ? parts.join(' · ') : 'STONE';
      } else {
        smallText = 'Select your'; mainText = 'STONE';
      }
    } else {
      smallText = 'Complete your'; mainText = 'RING';
    }

    var useDiamondThumb = isDiamondStep && hasDiamond && s.state === 'completed';
    var useSettingThumb = isSettingStep && hasRing && s.state === 'completed';
    var thumbSrc = null;
    var dataAttr = '';
    if (useDiamondThumb) {
      thumbSrc = diamond.cover_pic || diamond.image || diamond.img || diamond.thumbnail;
    } else if (useSettingThumb) {
      dataAttr = ' data-setting-thumb';
    }
    if (useDiamondThumb || useSettingThumb) cls += ' sp-progress__step--has-thumb';

    var clickUrl = '';
    if (isSettingStep) {
      clickUrl = hasRing && ring.handle ? ring.handle : '/collections/engagement-rings';
    } else if (isDiamondStep) {
      clickUrl = hasDiamond
        ? ('/products/diamonds?sku=' + encodeURIComponent(diamond.sku))
        : '/collections/lab-diamonds';
    }
    var clickAttr = clickUrl ? ' onclick="window.location.href=\'' + clickUrl + '\'"' : '';
    var clickCls = clickUrl ? ' sp-progress__step--clickable' : '';

    html += '<div class="' + cls + clickCls + '"' + clickAttr + '>';
    html += '<div class="sp-progress__num">' + (i + 1) + '</div>';
    html += '<div class="sp-progress__text"' + (isSettingStep ? ' data-setting-text' : (isDiamondStep ? ' data-diamond-text' : '')) + '><span class="sp-progress__text-small">' + esc(smallText) + '</span><span class="sp-progress__text-main">' + esc(mainText) + '</span></div>';
    if (thumbSrc) {
      html += '<div class="sp-progress__thumb"><img src="' + esc(thumbSrc) + '" alt="' + esc(diamond && diamond.shape || 'Diamond') + '"></div>';
    } else if (useSettingThumb) {
      html += '<div class="sp-progress__thumb"' + dataAttr + '></div>';
    } else {
      html += '<div class="sp-progress__icon">' + icons[iconKey] + '</div>';
    }
    html += '</div>';
  }
  html += '<a href="javascript:void(0)" class="sp-progress__restart" id="sp-global-restart">Start Over</a></div>';

  var container = wrap.querySelector('.sp-progress-container');
  if (container) container.innerHTML = html;

  // v47: async fetch only overwrites text on COMPLETED setting step (not active)
  if (hasRing && ring.handle) {
    var handle = ring.handle.indexOf('/products/') === 0 ? ring.handle : ('/products/' + ring.handle);
    fetch(handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        var vid = parseInt(ring.vid, 10);
        var v = (p.variants || []).find(function(x){ return x.id === vid; });
        var imgUrl = (v && v.featured_image && (v.featured_image.src || v.featured_image))
                     || p.featured_image
                     || (p.images && p.images[0])
                     || null;
        if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;

        var slot = document.querySelector('.sp-progress__thumb[data-setting-thumb]');
        if (slot && imgUrl) {
          var img = document.createElement('img');
          img.src = imgUrl;
          img.alt = p.title || 'Setting';
          slot.appendChild(img);
        }
        // Only replace the main label on completed steps (thumbnail was already
        // gated on completed). Prevents "Select your SUN BELT SETTING" hybrid.
        var txt = document.querySelector('.sp-progress__step--completed [data-setting-text] .sp-progress__text-main');
        if (txt && p.title) {
          txt.textContent = p.title.toUpperCase();
        }
      })
      .catch(function(){});
  }

  var restart = document.getElementById('sp-global-restart');
  if (restart) {
    restart.addEventListener('click', function() {
      document.cookie = '_ring=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_diamonmd=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_diamond=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_selectedShapes=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      window.location.href = '/collections/engagement-rings';
    });
  }

})();
